
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as fromAuth from 'app/core/state/reducers';
import { filter, map, switchMap, take } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private store: Store
    ) { }

    private waitForAuthInitialized() {
        return this.store.pipe(
            select(fromAuth.selectAuthInitialized),
            filter(initialized => initialized === true),
            take(1)
        );
    }

    private isLoggedIn() {
        return this.store.pipe(
            select(fromAuth.selectLoggedIn),
            map(isLoggedIn => isLoggedIn)
        );
    }

    canActivate() {
        return this.store.pipe(
            select(fromAuth.selectAuthInitialized),
            take(1),
            switchMap(initialized => {

                // if (!initialized) {
                //     this.authService.getCurrentUser();
                // }

                return this.waitForAuthInitialized().pipe(
                    switchMap(() =>
                        this.isLoggedIn().pipe(
                            map(isLoggedIn => {
                                if (!isLoggedIn) {
                                    this.router.navigate(['app/login'], { replaceUrl: true });
                                    return false;
                                }
                                return true;
                            })
                        )
                    )
                );
            })
        );
    }
}
